import React from 'react'
import { observer } from 'mobx-react-lite'
import { StoreSettingsPage } from '../StoreSettingsPage'
import { CommissionsSettings } from '../CommissionsSettings'
import { YandexMarketApiSettings } from './YandexMarketApiSettings'
import { YandexMarketStoresForm } from '../../YandexMarketStoresForm'
import { YandexMarketOrdersSettings } from './YandexMarketOrdersSettings'
import { YandexMarketPricesSettings } from './YandexMarketPricesSettings'
import { YandexMarketReturnsSettings } from './YandexMarketReturnsSettings'
import { YandexMarketSuppliesSettings } from './YandexMarketSuppliesSettings'

import { useMessages } from '../../../hooks/snackbarHooks'
import { useApi, useStore } from '../../../hooks/storeHook'
import { useYmAccountOptional } from '../../../hooks/routeHooks'

import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'
import { EditStoreAccountMsDataModel } from '../../../server/mpsklad_core/Models/EditStoreAccountMsDataModel'

export const YandexMarketSettingsPage =
  observer(() => {
    const api = useApi()
    const store = useStore()
    const {showSuccess} = useMessages()

    const account = useYmAccountOptional()

    const onSubmitMsData =
      async (msData: EditStoreAccountMsDataModel) => {
        try {
          const editedAccount = await api.userSync.editYmMsData(msData)
          store.syncStore.replaceStoreAccount(editedAccount)
          showSuccess('Сохранено!')
        } catch (e) {
          console.error('Failed to edit YM MS data', e)
        }
      }

    return (
      <StoreSettingsPage
        key={account?.id ?? 0}
        account={account}
        integrationType={IntegrationType.YandexMarket}
        allowSuppliesSettings={true}
        onSubmitMsData={onSubmitMsData}
        ApiSettingsComponent={YandexMarketApiSettings}
        OrdersSettingsComponent={YandexMarketOrdersSettings}
        WarehousesSettingsComponent={YandexMarketStoresForm}
        ReturnsSettingsComponent={YandexMarketReturnsSettings}
        CommissionsSettingsComponent={CommissionsSettings}
        PricesSettingsComponent={YandexMarketPricesSettings}
        SuppliesSettingsComponent={YandexMarketSuppliesSettings}
      />
    )
  })